import { CustomSvgIcon } from "modules/common/components/CustomSvgIcon"

export const ArrowNext = () => (
  <CustomSvgIcon width="16" height="15" viewBox="0 0 16 15" fill="none" style={{ width: 20, height: 20}}>
    <path d="M14.333 7.33442L0.33301 7.33442M14.333 7.33442L8.03301 13.5566M14.333 7.33442L8.03301 1.1122" stroke="#FDFF5D" strokeWidth="2"/>
  </CustomSvgIcon>
)
